
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface FormActionsProps {
  isUploading: boolean;
  onCancel: () => void;
  isEditing: boolean;
  onSubmitAndContinue?: () => void;
}

const FormActions: React.FC<FormActionsProps> = ({
  isUploading,
  onCancel,
  isEditing,
  onSubmitAndContinue,
}) => {
  return (
    <div className="flex justify-end gap-2 pt-4">
      <Button type="button" variant="outline" onClick={onCancel}>
        Cancel
      </Button>
      <Button type="submit" disabled={isUploading}>
        {isUploading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
        {isEditing ? "Update" : "Create"} Staff
      </Button>
      {!isEditing && onSubmitAndContinue && (
        <Button 
          type="button" 
          onClick={onSubmitAndContinue}
          disabled={isUploading}
          className="bg-blue-600 hover:bg-blue-700"
        >
          {isUploading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          Create & Edit Full Details
        </Button>
      )}
    </div>
  );
};

export default FormActions;
